module.exports = __webpack_public_path__ + "img/icon_5-1.77109380.png";